module.exports = require("@seddi/ui-recolor");